import { useQuery } from '@apollo/client';

import { queryParams } from 'app/shared/utils/queries';
import {
  GetPaymentMethodsData,
  GetPaymentMethodsVariables,
} from 'app/shared/typings/payments';

import { GET_PAYMENT_METHODS } from './queries';

export const GetPaymentMethods = (params: GetPaymentMethodsVariables = {}) => {
  return useQuery<GetPaymentMethodsData>(
    GET_PAYMENT_METHODS,
    queryParams(params)
  );
};
